import { render, staticRenderFns } from "./GameBuilderConfigStep.vue?vue&type=template&id=116046ea&"
import script from "./GameBuilderConfigStep.vue?vue&type=script&lang=js&"
export * from "./GameBuilderConfigStep.vue?vue&type=script&lang=js&"
import style0 from "./GameBuilderConfigStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports